import http from '@/plugins/request'

//入库单列表
export const getInWarehouseList = (params) => {
    return http.request({
        url: 'fch/pda/inWarehouse',
        method: 'get',
        params
    })
}
// 入库单详情
export const getInWarehouseMore = (sn) => {
  return http.request({
      url: 'fch/pda/inWarehouse/'+sn,
      method: 'get'
  })
}
// 入库单二维码明细
export const getInWarehousingCode = (params) => {
  return http.request({
      url: 'fch/pda/inWarehouse/warehousingCode/'+params.sn,
      method: 'get',
      params
  })
}
//入库
export const setInWarehouse = (data) => {
  return http.request({
    url: 'fch/pda/inWarehouse',
    method: 'POST',
    data
  })
}
// 垛标入库
export const setInWarehouseStoreV2 = (data) => {
  return http.request({
    url: 'fch/pda/inWarehouse/storeV2',
    method: 'POST',
    data
  })
}

//按单入库
export const setOrderInWarehouse = (data) => {
  return http.request({
    url: 'fch/pda/inWarehouse/scan/'+data.warehousing_sn,
    method: 'POST',
    data
  })
}
// 按单垛标入库
export const setOrderInWarehouseV2 = (data) => {
  return http.request({
    url: 'fch/pda/inWarehouse/scanV2/'+data.warehousing_sn,
    method: 'POST',
    data
  })
}
//生成入库单号
export const getInWarehouseSn = (data) => {
  return http.request({
    url: 'fch/pda/inWarehouse/sn',
    method: 'POST',
    data
  })
}
//后关联 - 提交操作
export const setAssociated = (data) => {
  return http.request({
    url: 'fch/pda/associated',
    method: 'POST',
    data
  })
}
//后关联 - 码信息
export const getAssociatedCode = (params) => {
  return http.request({
    url: 'fch/pda/associated/code',
    method: 'get',
    params
  })
}
//后关联 - 码信息
export const codeDissolve = (data) => {
  return http.request({
    url: 'fch/pda/dissolve',
    method: 'POST',
    data
  })
}
//选择入库单的列表
export const getSelectInWarehouseList = (params) => {
  return http.request({
      url: 'fch/pda/inWarehouse/list',
      method: 'get',
      params
  })
}
//后关联 - 套码提交操作
export const codeAssociated = (data) => {
  return http.request({
    url: 'fch/pda/associated/codeAssociated',
    method: 'POST',
    data
  })
}
//后关联 - 防伪码套码提交操作
export const securityCodeAssociated = (data) => {
  return http.request({
    url: 'fch/pda/associated/securityCodeAssociated',
    method: 'POST',
    data
  })
}
//解除码关系 - 垛标
export const codeDissolveVirtual = (data) => {
  return http.request({
    url: 'fch/pda/virtualDissolve',
    method: 'POST',
    data
  })
}


//二三级关联后入库-V3
export const setInWarehouseV3 = data => {
  return http.request({
    url: "fch/pda/associatedV3/inWarehouse",
    method: "POST",
    data
  });
};


//后关联 - 箱盒关联提交操作
export const setPackageAssociated = data => {
  return http.request({
    url: "fch/pda/associatedV3/boxAssociated",
    method: "POST",
    data
  });
};

// 盒瓶关联 码查询
export const boxAssociatedCodeInfo = params => {
  return http.request({
    url: "fch/pda/associatedV3/boxAssociatedCodeInfo",
    method: "get",
    params
  });
};


//后关联 - 码信息V3
export const getAssociatedV3Code = params => {
  return http.request({
    url: "fch/pda/associatedV3/code",
    method: "get",
    params
  });
};

//盒瓶关联
export const subsectionCodeRelationLower = data => {
  return http.request({
    url: "fch/pda/associatedV3/subsectionCodeRelationLower",
    method: "POST",
    data
  });
};
//盒瓶关联-查询
export const searchSubsectionCodeRelationLower = data => {
  return http.request({
    url: "fch/pda/associatedV3/querySubsectionCodeRelationLower",
    method: "post",
    data
  });
};
//盒瓶关联-解除
export const removeSubsectionCodeRelationLower = data => {
  return http.request({
    url: "fch/pda/associatedV3/removeSubsectionCodeRelationLower",
    method: "POST",
    data
  });
};
